import { p as parse } from './index-b3f1c3a1.js';
var SECOND_IN_MS = 1000;
var MINUTE_IN_MS = 60 * SECOND_IN_MS;
var HOUR_IN_MS = 60 * MINUTE_IN_MS;
var DAY_IN_MS = 24 * HOUR_IN_MS;
// Not precisely accurate, only estimates. exact duration depends on start date. use with care.
var MONTH_IN_MS = 30 * DAY_IN_MS;
var YEAR_IN_MS = 12 * MONTH_IN_MS;
/**
 * ConvertMS is a helper function that will take in milliseconds and convert it to the highest detonator
 * and does not return the "remainder"
 *
 * It is important to note that the object returning does not represent equivalence!
 *
 * For Example:
 * convert(MINUTE_IN_MS) will return:
 * {
 *   day: 0,
 *   hour: 0
 *   minute: 1,
 *   seconds: 0,
 * }
 *
 * IT DOES NOT RETURN:
 *
 * {
 *   day: 0,
 *   hour: 0,
 *   minute: 1,
 *   seconds: 60, <--- does not return the "equivalence"
 * }
 */
var convertMS = function (milliseconds) {
    if (milliseconds < 0) {
        throw new Error('Time cannot be negative!');
    }
    var seconds = Math.floor(milliseconds / 1000);
    var minute = Math.floor(seconds / 60);
    var hour = Math.floor(minute / 60);
    var day = Math.floor(hour / 24);
    seconds %= 60;
    minute %= 60;
    hour %= 24;
    return {
        day: day,
        hour: hour,
        minute: minute,
        seconds: seconds,
    };
};
var displayDate = function (date, resolution, _a) {
    var start = _a.start, end = _a.end;
    var viewportDurationMS = end.getTime() - start.getTime();
    if (resolution < HOUR_IN_MS) {
        if (viewportDurationMS < MINUTE_IN_MS) {
            return date.toLocaleString('en-US', {
                minute: 'numeric',
                second: 'numeric',
            });
        }
        if (viewportDurationMS <= 10 * MINUTE_IN_MS) {
            return date.toLocaleString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true,
            });
        }
        if (viewportDurationMS <= HOUR_IN_MS) {
            return date.toLocaleString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            });
        }
        if (viewportDurationMS <= DAY_IN_MS) {
            return date.toLocaleString('en-US', {
                hour12: true,
                hour: 'numeric',
                month: 'numeric',
                minute: 'numeric',
                day: 'numeric',
            });
        }
        if (viewportDurationMS <= MONTH_IN_MS) {
            return date.toLocaleString('en-US', {
                hour12: true,
                hour: 'numeric',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            });
        }
        return date.toLocaleString('en-US', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
        });
    }
    if (resolution <= HOUR_IN_MS) {
        return date.toLocaleString('en-US', {
            hour: 'numeric',
            day: 'numeric',
            month: 'numeric',
            hour12: true,
        });
    }
    if (resolution < DAY_IN_MS) {
        return date.toLocaleString('en-US', {
            day: 'numeric',
            month: 'numeric',
        });
    }
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });
};
var parseDuration = function (duration) {
    if (typeof duration === 'number') {
        return duration;
    }
    var parsedTime = parse(duration, 'ms');
    // if duration is a string but we cannot parse it, we default to 10 mins.
    return parsedTime != null ? parsedTime : 10 * MINUTE_IN_MS;
};
export { DAY_IN_MS as D, HOUR_IN_MS as H, MINUTE_IN_MS as M, SECOND_IN_MS as S, YEAR_IN_MS as Y, MONTH_IN_MS as a, convertMS as c, displayDate as d, parseDuration as p };
